import { create } from "zustand"

type HighZBottomSheetState = {
  isOpen: boolean
  content: React.ReactNode
  naviHeight: number | null
  naviBackButton: boolean | null
  isBackground: boolean | null
  openSheet: (
    content: React.ReactNode,
    naviHeight?: number,
    naviBackButton?: boolean,
    isBackground?: boolean,
  ) => void
  closeSheet: () => void
  setNaviHeight: (height: number) => void
}

export const useHighZBottomSheetStore = create<HighZBottomSheetState>(
  (set) => ({
    isOpen: false,
    content: null,
    naviHeight: null,
    naviBackButton: true,
    isBackground: null,
    openSheet: (content, naviHeight, naviBackButton, isBackground) =>
      set({
        isOpen: true,
        content,
        naviHeight: naviHeight ?? null,
        naviBackButton: naviBackButton ?? true,
        isBackground: isBackground ?? null,
      }),
    closeSheet: () =>
      set({
        isOpen: false,
        content: null,
        naviHeight: null,
        naviBackButton: null,
        isBackground: null,
      }),
    setNaviHeight: (height) => set({ naviHeight: height }),
  }),
)
